<template>
  <section class="about-us-cite text-center relative">
    <div class="page-container">
      <div class="about-us-cite__wrapper relative mb8 locked" data-aos="fade-up">
        <h1 class="about-us-cite__title mb4">
          We&nbsp;help salespeople
          <em class="relative px1">build the careers</em>
          they&nbsp;deserve
        </h1>

        <p class="about-us-cite__subtitle">
          Bravado is&nbsp;the professional network to&nbsp;help B2B Sellers thrive in&nbsp;their careers.
          <br class="hidden-md" />
          Get access to&nbsp;everything you need to&nbsp;land a&nbsp;great job, get promoted, and grow your career.
        </p>

        <NuxtLink data-test="about-page-jobs-button" class="about-us-cite__link" to="/jobs/welcome">
          Jobs @ Bravado
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'AboutUsCite',
});
</script>

<style lang="scss" scoped>
.about-us-cite {
  z-index: 1;

  @include mq('md') {
    margin-bottom: 125px;
  }

  &__wrapper {
    background: url('~@/components/partials/landings/about-us/images/bg/cite-bg.svg') no-repeat center top var(--white);
    background-size: cover;
    border-radius: 16px;
    z-index: 1;
    padding: 38px 24px 35px;

    @include mq('md') {
      padding: 60px 24px;
      border-radius: 32px;
    }
  }

  &__title {
    font-weight: 600;
    color: var(--color-text);
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.5px;

    @include mq('md') {
      font-size: 33px;
      line-height: 40px;
      letter-spacing: -1px;
      margin-bottom: 20px;
    }

    em {
      font-style: normal;
      color: var(--theme-purple_hc_1);
      white-space: nowrap;

      @include mq('md') {
        font-style: italic;
        margin-right: 2px;
      }

      &::after {
        content: '';
        height: 12px;
        width: 253px;
        background: url('~@/components/partials/landings/about-us/images/bg/cite-underline.svg') no-repeat left top;
        background-size: 180px 9px;
        position: absolute;
        bottom: -7px;
        left: -5px;
        animation: underline-cite-animation 1.5s;

        @include mq('md') {
          background-size: 253px;
          bottom: -8px;
          left: -1px;
        }
      }
    }
  }

  &__subtitle {
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: var(--color-text);
    max-width: 650px;
    margin: 0 auto 40px;

    @include mq('md') {
      font-size: 20px;
      line-height: 32px;
    }
  }

  &__link {
    padding: 20px 40px;
    color: white;
    background: linear-gradient(82.4deg, #755275 0%, #8a92ce 106.45%);
    border-radius: 10px;
    cursor: pointer;
    font-weight: 600;
  }
}

@keyframes underline-cite-animation {
  from {
    width: 0;
  }

  to {
    width: 250px;
  }
}
</style>
